import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorsHandlerService {
  constructor(private dialog: MatDialog) {}

  error(errors: Error) {
    this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Lỗi hệ thống',
        content: errors.message,
        type: 'error',
      },
    });
  }
}
